module.exports = __webpack_public_path__ + "static/img/40015 (4).1343775.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40015 (4).webp
// module id = 0LBb
// module chunks = 14